import classNames from 'classnames';
import React from 'react'
import useMediaQuery from 'utils/hooks/useMediaQuery';
import { ATTRS_TO_ASSING_LOCAL_LOGOS } from '../../../../utils/sustainabilityActions';
import "./styles/RenderCertificateImg.scss"
import { LG } from 'constants/breakpoints';

const RenderCertificateImg = ({
  link, 
  sustainabilityProperty, 
  fieldWithExpirateCertification,
  notHaveCertificate
}) => {
  const imgClassName = sustainabilityProperty.title + "Img";
  const isLocalLogo = ATTRS_TO_ASSING_LOCAL_LOGOS.includes(sustainabilityProperty.title);

  const isMobile = useMediaQuery(LG);
  const fieldExpiredData = fieldWithExpirateCertification?.props?.expiredData
  const { formattedExpiresDate = null } = fieldExpiredData ?? {}

  const heightCertificateImgContainer = { heihgt: "100px" }

  return (
    <div
      className={classNames({
        "d-flex": true,
        "flex-row justify-content-center align-items-start": isMobile,
        "flex-column justify-content-center mr-3 align-items-start": !isMobile,
        "pr-3": !fieldExpiredData,
      })}
      style={heightCertificateImgContainer}
    >
      {!notHaveCertificate ? (
        <a
          className="mx-auto d-flex align-items-center"
          href={link + sustainabilityProperty.certificate}
          style={{ height: "74px" }}
        >
          <img
            className={imgClassName}
            src={
              !isLocalLogo
                ? link + sustainabilityProperty.logoImg
                : sustainabilityProperty.logoImg
            }
            width={70}
          />
        </a>
      ) : (
        <img
          className={imgClassName}
          src={
            !isLocalLogo
              ? link + sustainabilityProperty.logoImg
              : sustainabilityProperty.logoImg
          }
          width={70}
        />
      )}
      {!notHaveCertificate && formattedExpiresDate && (
        <div
          className={classNames({
            "mt-2 d-flex": true,
            "align-items-end": !isMobile,
            "align-items-start": isMobile,
          })}
          style={{ height: "30px" }}
        >
          {fieldWithExpirateCertification}
        </div>
      )}
    </div>
  );
}

export default RenderCertificateImg